import React, { useEffect, useState } from "react";

const DynamicTabs = ({ tabs, defaultTab, activeTab: controlledTab, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  // 🔥 Sync with parent (URL-based tab)
  useEffect(() => {
    if (controlledTab) {
      setActiveTab(controlledTab);
    }
  }, [controlledTab]);

  return (
    <div className="p-3 rounded">
      {/* Tabs Header */}
      <div className="flex gap-4 border-b">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => {
              setActiveTab(tab.id);
              onTabChange?.(tab);
            }}
            className={`pb-2 text-md font-semibold ${
              activeTab === tab.id
                ? "border-b-2 border-cyan-500 text-cyan-500"
                : "text-gray-500"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tabs Content */}
      <div className="pt-4">
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div key={tab.id}>{tab.component}</div>
            )
        )}
      </div>
    </div>
  );
};

export default DynamicTabs;